<template>
  <span :class="`bundle bundle-${current_color}`">{{ $t(`core.document.status.${value}`) }}</span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      current_color() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'approved':
            return 'green';
          case 'new':
            return 'blue';
          case 'rejected':
            return 'error';
          default:
            return 'yell';
        }
        /* eslint-enable */
      }
    }
  };
</script>
